import React from "react"
import styled from "styled-components"

import { Link } from "gatsby"

import Layout from "../components/layout"
import Footer from "../components/footer"
import SEO from "../components/seo"
import LogoSVG from '../images/svg/ouroboros-logo.svg'
import theme from '../theme/theme'

import bgImg from '../images/ouroboros-game-landing-page-background.png';
import bgImgSm from '../images/ouroboros-game-landing-page-background.jpg';

const SiteWrap = styled.div`
  height:100vh;
  width:100vw;
  background-size: cover;
  padding: 0 15%;  

  @media(max-width:767px) {
    background-image: url(${bgImgSm});
    padding: 0 10%;
  }
  @media(min-width:768px) {
    background-image: url(${bgImg});
    padding: 0 15%;
  }
`

const MainContent = styled.main`
  display:flex;
  align-items: center;
  height:80%;
`

const SvgWrap = styled.div`
	position: relative;
	width: 100%;
	padding-bottom: 15%; 
	vertical-align: middle; 
  overflow: hidden;
  margin-bottom: 3rem;
  > svg {
	  position: absolute;
	  height: 100%; 
    width: 100%; 
    left: 0; 
    top: 0;
  }
`

const HomeIntro = styled.div`
  max-width:420px;
  border-left: 1px solid ${theme.primaryColor};
  padding-left: 1rem;
  margin-bottom: 3rem;
  h2 {
    text-transform:uppercase;
  }
`

const Button = styled.button`
    background-color: #fff;
    border-width: 0px;
    border-radius: 20px;
    color: ${theme.secondaryColor};
    cursor: pointer;
    justify-content: center;
    padding: 10px 20px;
    text-align: center;
    white-space: nowrap;
    text-transform: uppercase;
    font-weight:bold;
`


const IndexPage = () => (
  <Layout>
    <SEO title="Ouroboros Home" keywords={[`IOHK`, `Cardano`, `Ouroboros`, `Game`]} />
    <SiteWrap>
      <MainContent>
        <div>
          <Link to='/'>
          <SvgWrap>
            <LogoSVG />
          </SvgWrap>
          </Link>
          <HomeIntro>
            <h2>Attack the protocol</h2>
            <p>Attack the protocol, fork the blockchain - or not. Explore the Ouroboros protocol firsthand in this interactive simulation.</p>
          </HomeIntro>
          <Link to="/ouroboros-game/">
            <Button>Get started</Button>
          </Link>
        </div>
      </MainContent>
      <Footer/>
    </SiteWrap>
  </Layout>
)

export default IndexPage
